import { render, staticRenderFns } from "./AgreementDetail.vue?vue&type=template&id=1980cff7&"
import script from "./AgreementDetail.vue?vue&type=script&lang=js&"
export * from "./AgreementDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgreementDetail.vue?vue&type=style&index=0&id=1980cff7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports